export const enum ApiFetchState {
    LOADING = 0,
    ERROR = 1,
    SUCCESS = 2,
}

export const enum WalletApiFetchState {
    DEFAULT = 0,
    LOADING = 1,
    ERROR = 2,
    SUCCESS = 3,
}
